import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setWriterSelection } from "../constants/actions";
import writers from "../constants/writers";
// import WriterBio from "./WriterBio";
import { Button } from "react-bootstrap";
import AuthContext from "../contexts/AuthContexts";
import StarRatings from "react-star-ratings";

const WriterSelectionStep2 = () => {
  const dispatch = useDispatch();
  const [selectedWriter, setSelectedWriter] = useState("");

  const handleWriterSelection = (writerId) => {
    setSelectedWriter(writerId);
  };

  const handleContinue = () => {
    // Dispatch an action to update the Redux store with the selected writer.
    dispatch(setWriterSelection(selectedWriter));
    // Move to the next step (Step 3: PaymentStep)
    // You can use Redux action to update the current step in the store.
  };
  const WriterBio = ({ writer }) => {
    // const [color, setColor] = useState(false);
    const [buttonText, setButtonText] = useState(false);
    const currentUser = useContext(AuthContext);
   
useEffect(()=>{
    if(!currentUser){
        window.location = '/login'
    }
})
    const dj = () => {
      // setColor(!color);
      setButtonText(!buttonText);
    };
    const buttonStyle = {
      fontSize: "13px",
      width: "max-content",
      background: buttonText? "green" : "black",
    };

    // const productRating = 4;
    return (
      <>
        {/* {
          writers.map((writer) => ( */}
        <div
          className="rounded-4 mt-3 mb-3 p-1  pt-3 shadow-lg m-sm-4 hover-border text-center"
          style={{
            maxWidth: "330px",
            maxHeight: "560px",
            // border: "1px solid blue",
            // overflow: "auto",
          }}
        >
          <img
            src={writer.imgSrc}
            className="rounded-circle mb-1"
            alt=""
            style={{ width: "100vw", maxWidth: "60px" }}
          />
          <h3>{writer.name}</h3>
          <div className="d-flex justify-content-center">
            <StarRatings
              rating={parseFloat(writer.rating)}
              starRatedColor="#F49F3F"
              numberOfStars={5}
              name="rating"
              starDimension="16px"
              starSpacing="2px"
            />
            <span className="m-1 fw-bold">{writer.rating}</span>
          </div>
          <p>
            <b>Projects Completed : {writer.projectsCompleted}</b>
          </p>
          <hr />
          <p style={{ color: "green" }}>
            <b>{writer.degree}</b>{" "}
          </p>
          <hr />

          {/* <p style={{maxHeight:'100px', overflow:'auto',color:'black'}}>{writer.bio}</p> */}
          {/* <hr /> */}
          <p className="fw-bold bgl" style={{ fontSize: "12px" }}>
            {writer.specializedIn}
          </p>
          <hr />
          <div className="d-flex align-items-start justify-content-around">
            <Button
              variant="btn-outline-dark"
              className="btn-lg p-3 btn-outline-dark"
              style={{ fontSize: "13px" }}
              onClick={() => {
                window.location = "writer-profile";
              }}
            >
              <strong>About Writer</strong>
            </Button>
            <Button
              variant="primary"
              className="btn-lg p-3 fw-bold"
              style={buttonStyle}
              onClick={() => {
                dj();
                handleWriterSelection(writer.id);
                handleContinue();
              }}
            >
              {buttonText ? "Selected" : "Hire Writer"}
            </Button>
          </div>
        </div>
       
      </>
    );
  };

  return (
    <div className="text-center bg-body">
      <div className=" d-flex flex-wrap justify-content-center">
        {writers.map((writer) => (
        //   <div key={writer.id} value={writer.id}>
           
            <WriterBio
            key={writer.id}
              style={{ maxWidth: "15rem", width: "95vw" }}
              writer={writer}
            />
            
        //   </div>
        ))}
      </div>
    </div>
  );
};

export default WriterSelectionStep2;
